export const SENSOR_READINGS_VALUE = "sensor_readings";

export const hasSensorData = (eventTypes = []) =>
  eventTypes.includes(SENSOR_READINGS_VALUE);

export const DEFAULT_FORM_DATA = {
  name: "",
  description: "",
  object_types: [],
  enabled: true,
  event_types: [],
  conditions: "",
  webhook: null,
  scope: [],
  appliances: [],
};

export const CONDITIONS_HELP =
  'Leave empty to fire on every event. Example: {"attr": "name", "op": "contains", "value": "Buffalo"}. ' +
  "Operators: eq, gt, gte, lt, lte, in, contains, regex. " +
  'Use {"and": [...]} or {"or": [...]} to combine several conditions.';

/** Turns the error of JSON.parse into a sentence a non technical user can act on. */
export const describeJsonError = (error) => {
  const message = error?.message || "";
  const lineColumn = message.match(/line (\d+) column (\d+)/);
  const position = message.match(/position (\d+)/);

  let where = "";
  if (lineColumn) {
    where = ` near line ${lineColumn[1]}, column ${lineColumn[2]}`;
  } else if (position) {
    where = ` near character ${Number(position[1]) + 1}`;
  }

  return (
    `The conditions are not written correctly${where}. Check for a missing ` +
    "quote, comma, colon or bracket, and that text is inside double quotes."
  );
};

/** Every message inside an error body, however deeply arrays and objects are nested. */
const collectMessages = (value) => {
  if (value === null || value === undefined) {
    return [];
  }
  if (typeof value === "string") {
    return value ? [value] : [];
  }
  if (Array.isArray(value)) {
    return value.flatMap(collectMessages);
  }
  if (typeof value === "object") {
    return Object.values(value).flatMap(collectMessages);
  }
  return [String(value)];
};

/** The message the server sends back for the conditions, as one string. */
export const getConditionsServerError = (error) =>
  collectMessages(error?.response?.data?.conditions).join(" ");

/** Value sent to the API when a mode-dependent field is inactive. */
export const MODE_FIELD_EMPTY_VALUES = {
  scope: [],
  appliances: [],
  object_types: [],
  conditions: null,
};
/** Every field whose presence depends on the selected mode. */
export const MODE_FIELDS = Object.keys(MODE_FIELD_EMPTY_VALUES);

export const EVENT_RULE_MODES = {
  sensor: {
    id: "sensor",
    fields: ["scope", "appliances"],
    required: [], // scope and appliances are optional
  },
  generic: {
    id: "generic",
    fields: ["object_types", "conditions"],
    required: ["object_types"],
  },
};

export const getEventRuleMode = (eventTypes = []) =>
  hasSensorData(eventTypes) ? EVENT_RULE_MODES.sensor : EVENT_RULE_MODES.generic;

/** Sensor data can't be mixed with other event types, so narrow the choices. */
export const filterEventTypeOptions = (eventTypes = [], options = []) => {
  if (hasSensorData(eventTypes)) {
    return options.filter((option) => option.value === SENSOR_READINGS_VALUE);
  }
  if (eventTypes.length > 0) {
    return options.filter((option) => option.value !== SENSOR_READINGS_VALUE);
  }
  return options;
};
